'use strict'

import historyState from '../helpers/history-state';

function init() {
  const skipLinks = document.querySelectorAll('.skip-to-link');

  [...skipLinks].forEach((link) => {
    const href = link.getAttribute('href');
    const targetEl = document.querySelector(href);
    const windowLocation = window.location.href;

    if(windowLocation.includes(href)) {
      historyState.set(document.title, windowLocation.replace(href, ''));
    }

    link.addEventListener('keydown', (event) => {
      if(event.keyCode === 13 || event.keyCode === 32){
        event.preventDefault();

        // I'm not happy about this, but it appears to be the only way
        // to make Webkit browsers play nice with focus()
        setTimeout(() => {
          targetEl.focus();
        }, 0);
      }
    });
  });
}

if ('querySelector' in document) {
  init();
}
